import BdTermsModal from "./BdTermsModal";
export type { BdTermsModalProps } from "./BdTermsModal";
export default BdTermsModal;
